import { Phone, MessageCircle, FileText } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { companyInfo } from '../data/pricing';
import { trackRewiringEvents } from '../utils/tracking';

export const MobileStickyCTA = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Don't show on the quote form page itself
  if (location.pathname === '/rewire-quote') {
    return null;
  }

  const handlePhoneClick = () => {
    trackRewiringEvents.phoneClick('mobile_sticky_cta');
  };

  const handleWhatsAppClick = () => {
    trackRewiringEvents.whatsappClick('mobile_sticky_cta');
  };

  const handleQuoteClick = () => {
    navigate('/rewire-quote');
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-gray-200 shadow-lg">
      <div className="grid grid-cols-3 divide-x divide-gray-200">
        {/* Call Button */}
        <a
          href={`tel:${companyInfo.phone}`}
          onClick={handlePhoneClick}
          className="flex flex-col items-center justify-center py-3 px-2 hover:bg-gray-50 active:bg-gray-100 transition-colors"
        >
          <Phone className="h-5 w-5 text-blue-600 mb-1" />
          <span className="text-xs font-semibold text-gray-900">Call</span>
        </a>

        {/* WhatsApp Button */}
        <a
          href={`https://wa.me/${companyInfo.whatsapp}?text=Hi%20Crescent%20Electrical%2C%20I%27m%20looking%20for%20a%20quote%20for%20a%20property%20rewire`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleWhatsAppClick}
          className="flex flex-col items-center justify-center py-3 px-2 hover:bg-gray-50 active:bg-gray-100 transition-colors"
        >
          <MessageCircle className="h-5 w-5 text-green-600 mb-1" />
          <span className="text-xs font-semibold text-gray-900">WhatsApp</span>
        </a>

        {/* Quote Button */}
        <button
          onClick={handleQuoteClick}
          className="flex flex-col items-center justify-center py-3 px-2 hover:bg-gray-50 active:bg-gray-100 transition-colors"
        >
          <FileText className="h-5 w-5 text-orange-600 mb-1" />
          <span className="text-xs font-semibold text-gray-900">Quote</span>
        </button>
      </div>
    </div>
  );
};
